import EditText from '../../blocks.simple/editText/editText'
import translate from '../../core/translate'
import React, { useState } from 'react'
import moment from 'moment'
import type { DateIntervalPickerValue, DateIntervalProps } from './DateInterval-types'

export const DateInterval = ({ onChange, dateBegin, dateEnd }: DateIntervalProps) => {
    const [begin, setBegin] = useState(() => moment(dateBegin))
    const [end, setEnd] = useState(() => moment(dateEnd))

    const changeDate = (type: 'begin' | 'end', value: DateIntervalPickerValue) => {
        if (!value) {
            return
        }

        const date = moment(value)
        onChange({ type, value: date.format('YYYY-MM-DD') })

        if (type === 'begin') {
            setBegin(date)
        } else {
            setEnd(date)
        }
    }

    return (
        <>
            <div style={{ marginRight: '20px' }}>
                <EditText
                    label={translate('startDate')}
                    dateValue={begin}
                    maxDate={end}
                    type="date"
                    onChange={(value: DateIntervalPickerValue) => changeDate('begin', value)}
                />
            </div>
            <div>
                <EditText
                    label={translate('endDate')}
                    dateValue={end}
                    minDate={begin}
                    maxDate={dateEnd}
                    type="date"
                    onChange={(value: DateIntervalPickerValue) => changeDate('end', value)}
                />
            </div>
        </>
    )
}
